import { BaseClient } from '../base-client.js';
import { BASE_URLS } from '../../config';

class SubscriptionClient extends BaseClient {
  constructor(config) {
    super(config);
    this.baseUrl = this.baseUrl || BASE_URLS.SUBSCRIPTION_API;
    if (this.isServer) {
      this.config.headers['X-API-TOKEN'] = this.config.API_TOKEN || this.config.headers['X-API-TOKEN'] || '';
    }
  }

  getCompany(slug = '', emailSuffix = '') {
    const url = 'corporate';
    return this.get({
      url,
      params: { slug, email_suffix: emailSuffix }
    });
  }

  validateActivationToken(token, email) {
    const url = `subscription-activation/${token}`;
    return this.get({
      url,
      params: {
        email
      }
    });
  }

  activateSubscription(email, password, hash, token) {
    const url = `subscription-activation/${token}`;
    return this.post({
      url,
      data: {
        username: email,
        password,
        hash
      },
    });
  }

  validateCompanyInput(slug, username, regCode = '', ip = '') {
    const url = 'corporate-validate';
    return this.get({
      url,
      params: {
        slug,
        username,
        registration_code: regCode,
        ip_address: ip
      }
    });
  }

  resetPasswordStart(username) {
    const url = 'password/reset';
    const data = { username };
    return this.post({ url, data });
  }

  validateToken(token) {
    const url = `password/reset/${token}/validate`;
    return this.post({ url });
  }

  resetPasswordComplete(token, password) {
    const url = `password/reset/${token}`;
    const data = { password };
    return this.post({ url, data });
  }
}

export { SubscriptionClient };
